var React = require('react');

class InviterForm extends React.Component {

    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.remove = this.remove.bind(this);
        this.update = this.update.bind(this);
        this.header = this.header.bind(this);
        this.getRoleOptions = this.getRoleOptions.bind(this);
    }

    header() {
        if (!this.props.hideHeader) {
            return (
                <div className="row margin-top-lg margin-bottom-lg">
                    <div className="col-sm-2 col-md-3"></div>
                    <div className="col-sm-8 col-md-6 text-left">
                        <div className="settings-header">
                            Invite Members to {this.props.brewery.name}
                        </div>
                    </div>
                    <div className="col-sm-2 col-md-3"></div>
                </div>
            )
        }
    }

    onClick() {
        this.props.actions.addInvitee()
    }

    remove(index) {
        this.props.actions.removeInvitee(index)
    }

    update(e, index) {
        const invitee = this.props.store.invitees[index];
        this.props.actions.updateInvitee(index, {
            ...invitee,
            email: e.target.value
        })
    }

    getRoleOptions(index) {
        if (this.props.adminOnly) {
            return (
                <select id={`invitee-role-${index}`} className="invite-role" name={`invite-${index}[role]`}>
                    <option selected disabled>Select Role..</option>
                    <option value='admin'>Admin</option>
                </select>
            )
        } else {
            return (
                <select id={`invitee-role-${index}`} className="invite-role" name={`invite-${index}[role]`}>
                    <option selected disabled>Select Role..</option>
                    <option value='owner'>Brewery: Owner</option>
                    <option value='brewer'>Brewery: Brewer</option>
                    <option value='view_only'>Brewery: View-Only</option>
                </select>
            )
        }
    }

    invites() {
        return this.props.store.invitees.map((invite, index) => {
                return (
                    <div className="invite" key={index}>
                        <div>
                            <input id={`invitee-${index}`} key={index} className="form-input invite-field"
                                   name={`invite-${index}[invitee]`}
                                   placeholder="Ex. name@example.com"
                                   value={this.props.store.invitees[index].email}
                                   onChange={(e) => {
                                       this.update(e, index)
                                   }}
                                   type="text"
                            />
                            {this.getRoleOptions(index)}
                            <div className="invite-close" onClick={() => {
                                this.remove(index)
                            }}>x
                            </div>
                        </div>
                    </div>
                )
            }
        );
    }

    render() { 
        return (
            <div className={'width-100 invite-form'}>
                {this.header()}
                <div className="row margin-bottom-lg margin-top-md">
                    <div className="col-sm-2 col-md-3"></div>
                    <div className="col-sm-8 col-md-6">
                        <div className="width-100 text-center">
                            <form action="/invite/create" method="post">
                                <input type='hidden' name='authenticity_token' value={this.props.authenticationToken}/>
                                {this.invites()}
                                <div className={`width-100 text-left padded`}>
                                    <a className="add-invite" onClick={this.onClick}>(+) Add another</a>
                                    <input hidden type='text' name='brewery_id' readOnly={true} value={this.props.brewery.id}/>
                                    <input hidden type='text' name='from_brewery_page' readOnly={true} value={this.props.fromBreweryPage}/>
                                    <input id='submit_invitations' className='submit float-right'
                                           type='submit'
                                           value={`Send Invitations`}/>
                                </div>
                            </form>
                        </div>

                    </div>
                    <div className="col-sm-2 col-md-3"></div>
                </div>
            </div>
        );
    }
}

export default InviterForm;